(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-announcement"] && !Shopify.designMode) return;
  try {
    (function () {
    // ─── COUNTDOWN (default) ────────────────────────────────────────
    function pad(n) {
      return String(n).padStart(2, '0');
    }

    function getTarget(el) {
      var daily = el.getAttribute('data-tb-daily') === 'true';
      var endAttr = (el.getAttribute('data-tb-end') || '').trim();
      if (!daily && endAttr) {
        var t = new Date(endAttr.replace(' ', 'T')).getTime();
        if (!isNaN(t)) return t;
      }
      // daily: next reset at 23:59:59 (or custom)
      var resetTime = '23:59:59';
      var parts = resetTime.split(':');
      var h = parseInt(parts[0], 10) || 0;
      var m = parseInt(parts[1], 10) || 0;
      var s = parseInt(parts[2], 10) || 0;
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), h, m, s, 0);
      if (end.getTime() <= Date.now()) end.setDate(end.getDate() + 1);
      return end.getTime();
    }

    function renderDefaultTimer() {
      var el = document.querySelector('#kopstorm_topbar_1 .ks-topbar-countdown');
      if (!el) return;
      var elH = el.querySelector('[data-unit="hr"]');
      var elM = el.querySelector('[data-unit="min"]');
      var elS = el.querySelector('[data-unit="sec"]');
      var dist = getTarget(el) - Date.now();
      if (dist < 0) dist = 0;
      var hrs = Math.floor(dist / 3600000);
      var mins = Math.floor((dist % 3600000) / 60000);
      var secs = Math.floor((dist % 60000) / 1000);
      if (elH) elH.textContent = pad(hrs);
      if (elM) elM.textContent = pad(mins);
      if (elS) elS.textContent = pad(secs);
    }

    // ─── UTM LOGIC ──────────────────────────────────────────────────
    var SK = 'kopstorm_utm_params';
    var container = document.getElementById('kopstorm_topbar_1');
    if (!container) return;

    // 1. gather params
    var params = {};
    try {
      var raw = sessionStorage.getItem(SK);
      if (raw && raw !== 'undefined') params = JSON.parse(raw);
    } catch (e) {
      try {
        sessionStorage.removeItem(SK);
      } catch (x) {}
    }
    try {
      new URLSearchParams(window.location.search).forEach(function (v, k) {
        params[k.toLowerCase()] = v.toLowerCase();
      });
      sessionStorage.setItem(SK, JSON.stringify(params));
    } catch (e) {}

    // 2. find matching UTM block
    var blocks = container.querySelectorAll('.kopstorm-utm-topbar');
    var defSlider = document.getElementById('kopstorm_topbar_default_slider');
    var winner = null;

    for (var i = 0; i < blocks.length; i++) {
      var b = blocks[i];
      var key = (b.dataset.utmKey || '').trim();
      var val = (b.dataset.utmValue || '').trim();
      var mt = (b.dataset.utmMatch || 'exact').trim();
      if (!key) continue;
      var pv = params[key];
      if (typeof pv === 'undefined') continue;
      if (!val) {
        winner = b;
        break;
      }
      var vals = val.split(',');
      for (var j = 0; j < vals.length; j++) {
        var av = vals[j].trim();
        if (!av) continue;
        if (mt === 'contains' ? pv.indexOf(av) !== -1 : mt === 'starts_with' ? pv.indexOf(av) === 0 : pv === av) {
          winner = b;
          break;
        }
      }
      if (winner) break;
    }

    // 3. toggle visibility
    if (winner) {
      winner.style.display = 'block';
      if (defSlider) defSlider.style.display = 'none';
      for (var k = 0; k < blocks.length; k++) {
        if (blocks[k] !== winner) blocks[k].style.display = 'none';
      }

      // apply UTM colour overrides
      var utmBg = winner.dataset.utmBg || '';
      var utmText = winner.dataset.utmTextColor || '';
      var utmLink = winner.dataset.utmLinkColor || '';
      var utmArrow = winner.dataset.utmArrowColor || '';
      if (utmBg) container.style.setProperty('background', utmBg, 'important');
      if (utmText) {
        var textEls = container.querySelectorAll('p, .kopstorm-utm-countdown');
        for (var t = 0; t < textEls.length; t++) {
          textEls[t].style.setProperty('color', utmText, 'important');
        }
      }
      if (utmLink) {
        var linkEls = container.querySelectorAll('a');
        for (var l = 0; l < linkEls.length; l++) {
          linkEls[l].style.setProperty('color', utmLink, 'important');
        }
      }
      if (utmArrow) {
        var arrowStyle = document.createElement('style');
        arrowStyle.id = 'kopstorm-utm-arrow-override';
        arrowStyle.textContent =
          '#kopstorm_topbar_1 .swiper-button-prev:after,' +
          '#kopstorm_topbar_1 .swiper-button-next:after{color:' +
          utmArrow +
          '!important}';
        if (document.body) document.body.appendChild(arrowStyle);
        else
          document.addEventListener('DOMContentLoaded', function () {
            document.body.appendChild(arrowStyle);
          });
      }
    } else {
      for (var k = 0; k < blocks.length; k++) blocks[k].style.display = 'none';
      if (defSlider) defSlider.style.display = '';
    }

    // ─── UTM COUNTDOWN ────────────────────────────────────────────
    function renderUTMTimer() {
      var timerEl = document.querySelector('.kopstorm-utm-countdown');
      if (!timerEl) return;
      var digitsEl = timerEl.querySelector('.kopstorm-utm-countdown__digits');
      if (!digitsEl) return;

      var isDaily = timerEl.dataset.timerDaily === 'true';
      var resetTime = timerEl.dataset.timerResetTime || '23:59:59';
      var endRaw = timerEl.dataset.timerEnd || '';

      function getDailyEndTs() {
        var parts = resetTime.split(':');
        var h = parseInt(parts[0], 10) || 0;
        var m = parseInt(parts[1], 10) || 0;
        var s = parseInt(parts[2], 10) || 0;
        var now = new Date();
        var end = new Date(now.getFullYear(), now.getMonth(), now.getDate(), h, m, s, 0);
        if (end.getTime() <= Date.now()) end.setDate(end.getDate() + 1);
        return end.getTime();
      }

      var endTs;
      if (isDaily) {
        endTs = getDailyEndTs();
      } else {
        if (!endRaw) return;
        endTs = new Date(endRaw.replace(' ', 'T')).getTime();
        if (isNaN(endTs)) return;
      }

      function tick() {
        var diff = endTs - Date.now();
        if (diff <= 0) {
          if (isDaily) {
            endTs = getDailyEndTs();
            diff = endTs - Date.now();
          } else {
            digitsEl.textContent = '00:00:00';
            return;
          }
        }
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        digitsEl.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      tick();
      setInterval(tick, 1000);
    }

    // ─── SWIPER INIT ──────────────────────────────────────────────
    function initSwipers() {
      try {
        if (winner) {
          var idx = winner.dataset.utmIndex;
          var swiperEl = container.querySelector('.kopstorm_topbar_utm_' + idx);
          var slideCount = swiperEl ? swiperEl.querySelectorAll('.swiper-slide').length : 0;
          var hasMultiple = slideCount > 1;

          new Swiper('.kopstorm_topbar_utm_' + idx, {
            navigation: hasMultiple
              ? { prevEl: '.swiper-button-prev_utm_' + idx, nextEl: '.swiper-button-next_utm_' + idx }
              : false,
            loop: hasMultiple,
            watchSlidesProgress: true,
            autoHeight: true,
            autoplay: hasMultiple ? { delay: 4000, enabled: true } : false,
            effect: hasMultiple ? 'fade' : undefined,
          });

          if (hasMultiple && swiperEl) {
            var arrows = swiperEl.querySelectorAll('.swiper-button-prev, .swiper-button-next');
            for (var a = 0; a < arrows.length; a++) arrows[a].classList.add('ks-show');
          }

          renderUTMTimer();
        } else {
          var defEl = document.getElementById('kopstorm_topbar_default_slider');
          var defSlideCount = defEl ? defEl.querySelectorAll('.swiper-slide').length : 0;
          var defHasMultiple = defSlideCount > 1;
          if (defEl) defEl.classList.toggle('ks-multi', defHasMultiple);

          new Swiper('.kopstorm_topbar_1', {
            navigation: defHasMultiple
              ? { prevEl: '.swiper-button-prev_slider', nextEl: '.swiper-button-next_slider' }
              : false,
            loop: defHasMultiple,
            watchSlidesProgress: true,
            autoHeight: true,
            autoplay: defHasMultiple ? { delay: 4000, enabled: true } : false,
            effect: defHasMultiple ? 'fade' : undefined,
          });

          if (defHasMultiple && defEl) {
            var arrows = defEl.querySelectorAll('.swiper-button-prev, .swiper-button-next');
            for (var a = 0; a < arrows.length; a++) arrows[a].classList.add('ks-show');
          }
        }
      } catch (e) {
        console.warn('[Announcement] Swiper init error:', e);
      }
    }

    // ─── START ─────────────────────────────────────────────────────
    renderDefaultTimer();
    setInterval(renderDefaultTimer, 1000);

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initSwipers);
    } else {
      initSwipers();
    }

    // Re‑init on theme editor section reload
    if (window.Shopify && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function (e) {
        if (e.target && e.target.querySelector && e.target.querySelector('#kopstorm_topbar_1')) {
          initSwipers();
        }
      });
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
